import { Flex, Grid, Icon, Text } from '@chakra-ui/react';

const RadioCard = ({
  icon,
  iconComponent,
  label,
  description,
  onClick,
  isSelected,
  isDisabled,
}) => {
  return (
    <Flex
      as='button'
      type='button'
      className={`rounded-xl px-4 py-3 sm:p-5 items-center justify-center border border-gray-200 transition-all duration-300 ease-in-out w-full text-left ${
        isSelected ? 'bg-gray-50' : ''
      } ${
        isDisabled
          ? 'cursor-not-allowed opacity-70'
          : 'cursor-pointer hover:bg-gray-50'
      }`}
      onClick={onClick}
      disabled={isDisabled}
    >
      <Grid className='grid-cols-[auto_1fr] gap-x-3 sm:gap-x-5 gap-y-1'>
        <Flex
          className={`${description && 'mt-1 row-span-2'} w-10 h-10 border border-gray-200 rounded-full items-center justify-center transition-colors duration-300 ease-in-out flex-shrink-0 ${
            isSelected ? 'bg-black text-white' : 'bg-gray-100 text-black'
          }`}
        >
          {iconComponent || (icon && <Icon as={icon} />)}
        </Flex>
        <Text className='font-medium text-lg self-center'>{label}</Text>
        {description && (
          <Text className='text-base text-gray-500'>{description}</Text>
        )}
      </Grid>
    </Flex>
  );
};

export default RadioCard;
